<template>
    <main-section>
        <v-layout column justify-center align-center>
            <v-sheet width="400">
                <v-card-title> 참여코드를 입력하세요. </v-card-title>
                <v-card-text>
                    <v-text-field
                        v-model="code"
                        v-bind="{
                            ...attrs_input,
                            errorMessages,
                        }"
                        hide-details="auto"
                        ref="code-input"
                    />
                </v-card-text>
                <v-card-actions>
                    <v-row>
                        <v-col>
                            <v-btn block @click="exit">취소</v-btn>
                        </v-col>
                        <v-col>
                            <v-btn block v-bind="{ loading }" @click="exec">참여하기</v-btn>
                        </v-col>
                    </v-row>
                </v-card-actions>
            </v-sheet>
        </v-layout>
    </main-section>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { attrs_input } from "@/assets/variables";
import MainSection from "@/components/client/main/main-section.vue";

export default {
    components: {
        MainSection,
    },
    data: () => ({
        code: null,

        loading: false,
        errorMessages: null,

        attrs_input,
    }),
    computed: {
        ...mapState("lecture", ["lecture", "isAccessible"]),
    },
    methods: {
        ...mapActions("lecture", ["getLecture"]),

        exit() {
            this.$router.go(-1);
        },

        async exec() {
            if (this.loading) return;
            else this.loading = true;

            this.errorMessages = null;

            try {
                const { code } = this;
                await this.getLecture({ code });

                if (!this.isAccessible) {
                    this.errorMessages = "유효하지 않은 참여코드입니다";

                    this.$nextTick(() => this.$refs["code-input"].focus());
                }
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style>
</style>